import { createFileRoute } from "@tanstack/react-router";

// Route
export const Route = createFileRoute("/_app/create/")();
